import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Pixelify_Sans, Silkscreen } from 'next/font/google'

const sans = Pixelify_Sans({
    subsets: ['latin']
})

const pixel = Silkscreen({
    subsets: ['latin'],
    weight: ['400', '700']
})

// --font-pixelify and --font-silkscreen are the names the arcade cabinet reads
const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${pixel.style.fontFamily};--font-app-heading:${pixel.style.fontFamily};--font-pixelify:${sans.style.fontFamily};--font-silkscreen:${pixel.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App